import React from "react";
import { Row, Col } from "antd";

import Tracking from "../../components/tracking2";

const Home = () => (
  <Row type="flex" justify="center">
    <Col span={24}>
      <Tracking showInfo showFind showTitle />
    </Col>
  </Row>
);

export default Home;
